<template>
  <div class="chat-wrapper">
    <app-overlay-loader v-if="preloader"/>
    <div class="chat-messages">
      <div class="message-header">
        <div class="contact-title">
          <h4 class="mb-0">{{ $t("task_comment") }}</h4>
        </div>
        <div class="contact-user">
          <!-- <div class="avatars-w-40">
            <div class="no-img rounded-circle avatar-shadow">RW</div>
          </div> -->
          <el-tooltip placement="top" :effect="theemMode.darkMode == true ? 'light' : 'dark'" :content="userList.full_name">
            <app-avatar
              :title="userList.full_name"
              class="mr-2"
              avatar-class="avatars-w-40"
              :img="''"
              :alt-text="$t('not_found')"
            />
          </el-tooltip>
        </div>
      </div>
      <div class="message-body">
        <div
          v-for="(comments,index) in allcomment"
          :key="index"
        >
        <el-divider>
          <small style="color:gray">{{index}}</small>
        </el-divider>
          <!-- <div class="text-center"><small style="color:gray">{{index}}</small></div>
          <hr class="mt-0"> -->
            <div v-for="(comment,index2) in comments" :key="index2">
          
              <div class="message" v-if="comment.user_id != user_id" style="flex-direction: inherit;display: flex;align-items: center;">
                   <el-tooltip placement="top" :effect="theemMode.darkMode == true ? 'light' : 'dark'" :content="comment.user.full_name">
                  <app-avatar
                    :title="comment.user.full_name"
                    class="mr-2"
                      avatar-class="avatars-w-40"
                      :img="''"
                      :alt-text="$t('not_found')"
                  />
                </el-tooltip>
                  
                  <div class="text" style="margin-left: 10px; border-radius: 15px 15px 15px 0px" >
                      <span> {{ comment.comment}}</span> <br >
                      <small> {{ timeConvert(comment.created_at)}} </small>
                  </div>
              </div>
              <div class="message"  v-if="comment.user_id == user_id">
                <el-tooltip placement="top" :effect="theemMode.darkMode == true ? 'light' : 'dark'" :content="comment.user.full_name">
                  <app-avatar
                    :title="comment.user.full_name"
                    class="mr-2"
                      avatar-class="avatars-w-40"
                      :img="''"
                      :alt-text="$t('not_found')"
                  />
                </el-tooltip>
                
                  
                  <div class="text">
                      <span> {{ comment.comment}}</span> <br >
                      <small> {{ timeConvert(comment.created_at) }} </small>
                  </div>
              </div>
        </div>
        </div>

        <div class="message" v-for="(message,i ) in messages" :key="i">
          <div class="avatars-w-40">
            <div>
                <app-avatar
                    :title="message"
                    class="mr-2"
                    avatar-class="avatars-w-40"
                    :img="''"
                    :alt-text="$t('not_found')"
                />
              <!-- <div class="no-img rounded-circle avatar-shadow">JD</div> -->
            </div>
          </div>
          <div class="text"><span>{{ message }}</span></div>
        </div>
      </div>
      <div class="message-editor">
        <div class="message-input">
          <div class="message-input-group">
               <app-input
                id="description"
                placeholder="Type something here..."
                type="text"
                v-model="inputs.comment"
                v-on:keyup.enter="submit"
              />
            <!-- <input type="hidden" class="form-control" :value="id" /> -->
            <div class="message-input-append">
              <a href="#" class="btn btn-send"  @click="submit">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-send size-15"
                >
                  <line x1="22" y1="2" x2="11" y2="13"></line>
                  <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {STORE_COMMENTS, GET_COMMENTS} from "../../../../Config/ApiUrl";
import { axiosPost, axiosPatch, axiosGet } from "../../../../Helpers/AxiosHelper";
    import {formatDateToLocal, onlyTime, optional} from "../../../../Helpers/Helpers";
export default {
  props: {
    comments: {
      type: Array,
    },
    id: Number,
  },
  data() {
    return {
      inputs:{
           task_id:''
      },
      messages:[],
      allcomment:[],
      user_id:"",
      preloader: true
    };
  },
    methods: {
       timeConvert(value) {
          return onlyTime(value);
        },
        
    GetComments() {
        this.preloader = true
        this.inputs.task_id = this.id ;
        axiosGet(GET_COMMENTS + "/" +  this.inputs.task_id)
        .then((res) => {
            this.allcomment = res.data.comment;
            this.user_id = res.data.user_id;
        })
        .catch((error) => {
            this.$toastr.e(error);
        }).finally(() => {
          this.preloader = false;
        });
    },
    submit() {
       this.inputs.task_id = this.id ;
      axiosPost(STORE_COMMENTS, this.inputs,)
        .then((res) => {
            this.messages.push(res.data);
            this.inputs.comment = '';
        })
        .catch((error) => {
          this.$toastr.e(error.data.message);
        });
    },
    afterSuccess(response) {
      this.$toastr.e(response.data.message);
    },
  },
  mounted(){
   
        setTimeout(() => {
           this.GetComments();
        }, 3000);
  },
   computed: {
      userList() {
        return this.$store.state.user.loggedInUser;
    },
    theemMode() {
      return this.$store.state.theme;
    },
   }
 
//    computed:{
    //    filterdata: function () {
    //       let  newarry = [];
    //     this.allcomment

    //   // `this` points to the vm instance
     
    //   this.allcomment.forEach(element => {
    //        
    //       if(element.user.id == this.user_id ) 
    //       { 
    //          this.newarry.push(element);
    //       }
    //   });
    //   return newarry
    
//     }
      
//   }
};
</script>
